import {css} from 'lit';
export const styles = css`.checkbox {
  display: flex;
  align-items: center;
  font-family: var(--font-family-base);
  font-size: var(--font-size-default);
  color: var(--color-neutral-600);
  line-height: var(--line-height-default);
  cursor: pointer;
  pointer-events: auto;
}
.checkbox--line {
  margin-right: var(--spacing-size-2xs);
}
.checkbox--list {
  display: flex;
  margin-bottom: var(--spacing-size-3xs);
}
.checkbox input {
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
  pointer-events: auto;
  border-radius: var(--border-radius-sm);
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  position: relative;
}
.checkbox input.has-label {
  margin-right: var(--spacing-size-4xs);
}
.checkbox input:focus:not(:focus-visible) {
  outline: transparent;
}
.checkbox input:focus-visible {
  outline: 2px solid var(--color-contrast-focused);
  outline-offset: 2px;
}
.checkbox input:before {
  position: absolute;
  content: "";
  display: block;
  width: 16px;
  height: 16px;
  box-sizing: border-box;
}
.checkbox input:after {
  position: absolute;
  content: "";
  display: block;
  width: 16px;
  height: 16px;
  border: var(--border-width-default) solid var(--color-neutral-300);
  border-radius: inherit;
  box-sizing: border-box;
}
.checkbox input:hover:before {
  background-color: var(--color-action-hover);
  opacity: var(--opacity-level-3);
  border-radius: var(--border-radius-sm);
}
.checkbox input:hover:after {
  border-color: var(--color-action-default);
}
.checkbox input:checked:before {
  background-color: var(--color-action-default);
  border-radius: var(--border-radius-sm);
}
.checkbox input:checked:hover:before {
  background-color: var(--color-brand-300);
  opacity: var(--opacity-level-3);
}
.checkbox input:checked:after {
  border-color: var(--color-action-default);
  background-color: var(--color-contrast-brand);
  -webkit-mask: url('data:image/svg+xml;utf-8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.99999 15.172L18.485 6.68606C18.8755 6.29553 19.5086 6.2954 19.8993 6.68577C20.2901 7.07633 20.2902 7.7098 19.8995 8.10049L10.0767 17.9233C10.0343 17.9657 9.96566 17.9657 9.92331 17.9233L4.34299 12.343C3.95252 11.9525 3.95252 11.3195 4.34299 10.929C4.73345 10.5385 5.36652 10.5385 5.75699 10.929L9.99999 15.172Z" fill="black"/></svg>');
  mask: url('data:image/svg+xml;utf-8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.99999 15.172L18.485 6.68606C18.8755 6.29553 19.5086 6.2954 19.8993 6.68577C20.2901 7.07633 20.2902 7.7098 19.8995 8.10049L10.0767 17.9233C10.0343 17.9657 9.96566 17.9657 9.92331 17.9233L4.34299 12.343C3.95252 11.9525 3.95252 11.3195 4.34299 10.929C4.73345 10.5385 5.36652 10.5385 5.75699 10.929L9.99999 15.172Z" fill="black"/></svg>');
  -webkit-mask-size: contain;
  mask-size: contain;
}
.checkbox input:checked ~ span {
  font-weight: var(--font-weight-semibold);
}
.checkbox input:disabled:before {
  background-color: var(--color-neutral-300) !important;
  opacity: var(--opacity-level-3) !important;
}
.checkbox input:disabled:after {
  color: var(--color-neutral-300);
  border-color: var(--color-action-default) !important;
  opacity: var(--opacity-level-3) !important;
}
.checkbox input:disabled ~ span {
  font-weight: var(--font-weight-regular);
  color: var(--color-neutral-300);
}
.checkbox input:disabled ~ span:checked {
  font-weight: var(--font-weight-semibold);
}
.checkbox input.indeterminate:before {
  background-color: var(--color-brand-300);
  opacity: var(--opacity-level-3);
}
.checkbox input.indeterminate:after {
  border: var(--border-width-default) solid var(--color-action-default);
  background-color: var(--color-contrast-brand);
  -webkit-mask: url('data:image/svg+xml;utf-8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12C5 11.4477 5.44772 11 6 11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H6C5.44772 13 5 12.5523 5 12Z" fill="black"/></svg>');
  mask: url('data:image/svg+xml;utf-8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12C5 11.4477 5.44772 11 6 11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H6C5.44772 13 5 12.5523 5 12Z" fill="black"/></svg>');
  -webkit-mask-size: contain;
  mask-size: contain;
}

.hidden-label {
  z-index: -9999;
  position: absolute;
  visibility: hidden;
}`;
export default styles;
